import {
  GET_DASHBOARD_ACTIVE_COURSE_LIST_SUCCESS,
  GET_DASHBOARD_CALENDAR_EVENT,
  GET_DASHBOARD_CALENDAR_EVENT_FAILED,
  GET_DASHBOARD_CALENDAR_EVENT_SUCCESS,
  GET_DASHBOARD_USER_COURSE_LIST,
  GET_DASHBOARD_USER_COURSE_LIST_FAILED,
  GET_DASHBOARD_USER_COURSE_LIST_SUCCESS,
} from "../constants";

export const initialState = {
  // Course
  dashboardCourse: [],
  dashboardCourseLoading: false,
  dashboardCourseError: "",
  dashboardActiveCourses: [],
  // calendar Events
  dashboardCalendarEventsLoading: false,
  dashboardCalendarEvents: [],
  dashboardCalendarEventsError: "",
};
export const DashboardReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_DASHBOARD_USER_COURSE_LIST:
      return {
        ...state,
        dashboardCourseLoading: true,
        dashboardCourse: [],
      };
    case GET_DASHBOARD_USER_COURSE_LIST_SUCCESS:
      return {
        ...state,
        dashboardCourseLoading: false,
        dashboardCourse: action.payload,
      };
    case GET_DASHBOARD_USER_COURSE_LIST_FAILED:
      return {
        ...state,
        dashboardCourseLoading: false,
        dashboardCourse: [],
        dashboardCourseError: action.payload,
      };
    case GET_DASHBOARD_ACTIVE_COURSE_LIST_SUCCESS:
      return {
        ...state,
        dashboardActiveCourses: action.payload,
      };
    case GET_DASHBOARD_CALENDAR_EVENT:
      return {
        ...state,
        dashboardCalendarEventsLoading: true,
        dashboardCalendarEvents: [],
      };
    case GET_DASHBOARD_CALENDAR_EVENT_SUCCESS:
      return {
        ...state,
        dashboardCalendarEventsLoading: false,
        dashboardCalendarEvents: action.payload,
      };
    case GET_DASHBOARD_CALENDAR_EVENT_FAILED:
      return {
        ...state,
        dashboardCalendarEventsLoading: false,
        dashboardCalendarEvents: [],
        dashboardCalendarEventsError: action.payload,
      };

    default:
      return state;
  }
};
